import axios from 'axios'
import type { AxiosRequestConfig } from 'axios'
import type { ContextoErro } from '@next/compartilhados/observabilidade'

type Requisicao = Pick<AxiosRequestConfig, 'method' | 'url' | 'baseURL' | 'allowAbsoluteUrls'>

/** Código ambíguo/ausência de response não comprovam timeout nem falha de rede. */
export const naturezaFalhaHttp = (status: number | undefined, codigo: string | undefined): NonNullable<ContextoErro['naturezaFalha']> => (
  status !== undefined ? 'http' : codigo === 'ETIMEDOUT' ? 'timeout' : codigo === 'ERR_NETWORK' ? 'rede' : 'desconhecida'
)

/** Metadados da requisição que falhou; não executa serializers nem copia params/headers/body. */
export const obterContextoRequisicaoHttp = (requisicao: Requisicao): Partial<ContextoErro> => {
  const contexto: Partial<ContextoErro> = typeof requisicao.method === 'string' ? { metodoHttp: requisicao.method } : {}
  try {
    if (!requisicao.url) return contexto
    // getUri conserva o prefixo de baseURL do Axios (new URL('/rota', baseURL) não conserva).
    const endereco = axios.getUri({
      url: requisicao.url,
      baseURL: requisicao.baseURL ?? '',
      allowAbsoluteUrls: requisicao.allowAbsoluteUrls ?? true,
      params: null,
    })
    const url = new URL(endereco, 'https://observabilidade.invalid/')
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return contexto
    return {
      ...contexto,
      endpoint: url.pathname,
      ...(url.host !== 'observabilidade.invalid' ? { servidorHttp: url.host } : {}),
    }
  } catch { return contexto }
}
